import React from 'react'
import { Card, VStack, HStack, Text, Heading, Icon } from '@chakra-ui/react'

interface StatsCardProps {
  label: string
  value: string | number
  subtitle?: string
  icon?: any
  iconColor?: string
  trend?: {
    value: number
    isPositive: boolean
  }
}

export const StatsCard: React.FC<StatsCardProps> = ({
  label,
  value,
  subtitle,
  icon,
  iconColor = 'blue.500',
  trend,
}) => {
  return (
    <Card.Root>
      <Card.Body p={5}>
        <VStack align="start" gap={2}>
          <HStack justify="space-between" w="full">
            <Text fontSize="sm" color="gray.500" fontWeight="medium">
              {label}
            </Text>
            {icon && <Icon as={icon} color={iconColor} />}
          </HStack>
          <Heading size="xl" color="gray.900">
            {value}
          </Heading>
          {subtitle && (
            <Text fontSize="xs" color="gray.400">
              {subtitle}
            </Text>
          )}
          {trend && (
            <Text
              fontSize="xs"
              color={trend.isPositive ? 'green.500' : 'red.500'}
            >
              {trend.isPositive ? '+' : ''}
              {trend.value}% vs last month
            </Text>
          )}
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}

